import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Loading } from 'src/app/Class/Loading';
import { PqrsService } from 'src/app/servicios/public/pqrs.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-encuesta-pqrs',
  templateUrl: './encuesta-pqrs.component.html',
  styleUrls: ['./encuesta-pqrs.component.css']
})
export class EncuestaPqrsComponent implements OnInit {

  public encuesta : any = {};

  constructor(private servi: PqrsService, private form: FormBuilder, 
    private rout: ActivatedRoute, public loading: Loading, private router: Router) {

      this.loading.estado = true;

      this.rout.params
      .subscribe(parametros => { 
        this.encuesta.token = encodeURIComponent(parametros['id']); 
        
        this.servi.EstadoEncuestaPQRS(this.encuesta.token)
        .subscribe((data:any) => {
          
            if (data.success) { window.location.href = "/"; }
            this.loading.estado = false;

        });

      });
 
     }

  ngOnInit() {
  }


  public guardar() {

    if( !(this.encuesta.prontitud && this.encuesta.coherencia && this.encuesta.claridad && this.encuesta.satisfacion) )
    {
      swal.fire('Para poder guardar debe llenar todas las respuestas', '', 'warning' );
      return;
    }

    this.loading.estado = true;

    this.servi.guardarEncuesta(this.encuesta)
    .subscribe( (data:any) => {
        
        if (data.success) 
        {
          swal.fire('Guardado exitoso', 'Gracias por su respuesta', 'success' );
          window.location.href = "/";
           
        } else {
          swal.fire({ type: 'warning', title: 'No se encontro su solicitud', showConfirmButton: false, timer: 1500 });
        }

        this.loading.estado = false;
    });
    
  }

}
